export default function formatPhoneNumber(number: string) {
  return '+48 ' + number.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
}
